import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Const
import { GUARD_GUEST, GUARD_USER } from 'constants/guards'
import { PATH_HOME, PATH_LOGIN } from 'routes/paths'

// Helpers
import { setReferrer } from 'helpers/auth'
import { unwrapResult } from '@reduxjs/toolkit'

// Services
import loading from 'services/loading'

// Use
import useMounted from 'use/mounted'
import { useDispatch, useSelector } from 'react-redux'

// Api
import { fetchUser } from 'store/modules/auth'

// Components
import { Route, useHistory, useLocation } from 'react-router-dom'

function RouteProtected({ path, exact, component, guard }) {
  const isMounted = useMounted()
  const location = useLocation()
  const history = useHistory()
  // State
  const user = useSelector((state) => state.auth.user)
  const dispatch = useDispatch()

  const [isOk, setIsOk] = useState(user && user.email)

  const checkGuard = useCallback(() => {
    // Show loading
    loading.show()

    dispatch(fetchUser())
      .then(unwrapResult)
      .then(() => {
        if (guard === GUARD_GUEST) {
          history.replace(PATH_HOME)

          return
        }

        if (isMounted.current) {
          setIsOk(true)
        }
      })
      .catch(() => {
        if (guard === GUARD_USER) {
          history.replace(PATH_LOGIN)

          setReferrer(location.pathname)

          return
        }

        if (isMounted.current) {
          setIsOk(true)
        }
      })
      .finally(() => {
        loading.hide()
      })
  }, [dispatch, guard, history, isMounted, location.pathname])

  useEffect(() => {
    checkGuard()
  }, [checkGuard])

  if (isOk) {
    return <Route path={path} exact={exact} component={component} />
  }

  return <div></div>
}

RouteProtected.propTypes = {
  path: PropTypes.string,
  exact: PropTypes.bool,
  component: PropTypes.any,
  guard: PropTypes.string,
}

RouteProtected.defaultProps = {
  path: '',
  exact: false,
  component: null,
  guard: '',
}

export default RouteProtected
